// extracted by mini-css-extract-plugin
export default {"clearHistoryBTN":"Discover_clearHistoryBTN__gXkXY","historyIMG":"Discover_historyIMG__o-s+B"};